const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Checks that a given UUID (e.g. projectId) is valid according to UUID_REGEX. */
export function isValidUuid(value: string): boolean {
  return UUID_REGEX.test(value);
}
